import React from 'react'
import { Grid, Image } from 'semantic-ui-react';
import { logoSimple } from '../assets/logo';
import { SocialMedia } from '../components';
import { ParallaxContainer } from '../components/ParallaxContainer';

const image = "https://images.pexels.com/photos/5709631/pexels-photo-5709631.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260";

const Banner = () => (
  <ParallaxContainer imageUrl={image} textColor='#fff'>
    <div style={styles.root}>
      <Grid columns={2} stackable>
        <Grid.Row>
          <Grid.Column>
            <Image src={logoSimple}/>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width='12'>
            <h1 style={styles.titleText}>Ahanar Sajghar</h1>
          </Grid.Column>
          <Grid.Column width='4'>
            <SocialMedia inverted/>   
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  </ParallaxContainer>
)

const styles = {
  root:  {
    margin: '100px',
    marginTop: '500px'
  },
  titleText: {
    fontSize: '80px',
    fontStyle: 'italic',
    color: '#fff'
  }
}

export {Banner};